export default function getCurrentLang(){
    const lang = document.querySelector('html').getAttribute('lang') || 'cs';
    return lang;
}